import { render, staticRenderFns } from "./FansRank.vue?vue&type=template&id=2527b682&scoped=true&lang=true&"
import script from "./FansRank.vue?vue&type=script&lang=js&"
export * from "./FansRank.vue?vue&type=script&lang=js&"
import style0 from "./FansRank.vue?vue&type=style&index=0&id=2527b682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527b682",
  null
  
)

export default component.exports